import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import { useParams, generatePath } from 'react-router';
import { useToasts } from 'react-toast-notifications';
import { useHistory } from 'react-router-dom';

const CouponDetail = (props) => {
  const { id, siteId, mallId } = useParams();
  const { user } = props;
  const [ticketBirthData, setTicketBirthData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();
  const history = useHistory();

  const [values, setValues] = useState({
    ticket_id: "",
    ticket_name: "",
    automatic_distribution_flag: constClass.FLAG.OFF,
    birth_flag: constClass.FLAG.OFF,
    gender: constClass.GENDER.MAN,
    expiry: "",
    end_month_flag: constClass.FLAG.OFF,
    release_date: "",
    message_text: "",
  });

  const refreshData = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    try {
      // 先にAPI実行
      const ticket_birth_promise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticketbirth/${siteId}/${mallId}/${id}`, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      });
      const ticket_birth = (await ticket_birth_promise).data;
      setTicketBirthData(ticket_birth);
      
      setValues({
        ticket_id: ticket_birth.ticket_id ? ticket_birth.ticket_id : id,
        ticket_name: ticket_birth.ticket_name ? ticket_birth.ticket_name : "",
        automatic_distribution_flag: ticket_birth.automatic_distribution_flag,
        birth_flag: ticket_birth.birth_flag,
        gender: ticket_birth.gender,
        expiry: ticket_birth.expiry || "",
        end_month_flag: ticket_birth.end_month_flag,
        release_date: ticket_birth.release_date || "",
        message_text: ticket_birth.message_text || "",
      });
    } catch (err) {
      console.log(err);
    }
  }, [siteId, id, mallId]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  const handleBackClick = () => {
    history.push(`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })}coupon`);
  }

  /* DB更新 */
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (data.end_month_flag === constClass.FLAG.OFF && !data.expiry) {
      window.alert('有効期限を入力してください。');
      return;
    }
    if (!data.release_date) {
      window.alert('配信日を入力してください。');
      return;
    }
    if (!data.gender) {
      window.alert('性別を選択してください。');
      return;
    }
    if (isNaN(Number(data.release_date)) || !Number.isInteger(Number(data.release_date)) || Number(data.release_date) < 1 || Number(data.release_date) > 31) {
      window.alert('配信日は1から31の数字で入力してください。');
      return;
    }
    if (data.message_text) {
      try {
        JSON.parse(data.message_text);
      } catch (e) {
        window.alert('通知メッセージ（Flex）は正しいJSON形式で入力してください。');        
        return;
      }
    }
    if (data.end_month_flag === constClass.FLAG.ON) {
      data.expiry = null;
    }

    var params = values;
    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;
    params.mall_id = mallId;

    let res;
    try {
      setLockData(true);
      if (ticketBirthData.ticket_id) {
        res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/ticketbirth/${values.ticket_id}`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      } else {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticketbirth/`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      }
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
    }
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  return (
    <div className="container">
      <div className="row mx-0 my-2 px-1-env">
        <div className="row col-12 mt-2 mb-2">
          <div className='col-2'>
            <button type="button"
              className={`btn btn-secondary mx-1 w-100 text-nowrap`}
              onClick={() => { handleBackClick() }}>
              戻る
            </button>
          </div>
        </div>
        <div className="col-2">
        </div>
        <div className="col-10">
          <div className="row mb-3 mt-4r">
            <div className="col-2 text-center align-self-center">
              <span>クーポンID</span>
            </div>
            <div className="col-1 text-center align-self-center">
              <span>{values.ticket_id}</span>
            </div>
            <div className="col-2 text-center align-self-center">
              <span>クーポン名</span>
            </div>
            <div className="col-2 text-center align-self-center text-nowrap">
              <span>{values.ticket_name}</span>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="automatic_distribution_flag">自動配信</label>
            </div>
            <div className="col-5 text-center align-self-center">
              <input type="checkbox" className="form-control w-25" name="automatic_distribution_flag" value="true" checked={values.automatic_distribution_flag === constClass.FLAG.ON} onChange={handleChange}></input>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="birth_flag">誕生月</label>
            </div>
            <div className="col-5 text-center align-self-center">
              <input type="checkbox" className="form-control w-25" name="birth_flag" value="true" checked={values.birth_flag === constClass.FLAG.ON} onChange={handleChange}></input>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="gender">性別</label>
            </div>
            <div className="row col-10">
              <div className="col-12">
                <div id="gender" name="gender" className="d-flex">
                  <div className="form-check col-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="gender-man"
                      name="gender"
                      value={constClass.GENDER.MAN}
                      checked={values.gender === constClass.GENDER.MAN}
                      onChange={handleChange}
                    />
                    <label className="form-check-label mx-2" htmlFor="gender-man">
                      {constClass.GENDER_NAME.MAN}
                    </label>
                  </div>
                  <div className="form-check col-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="gender-woman"
                      name="gender"
                      value={constClass.GENDER.WOMAN}
                      checked={values.gender === constClass.GENDER.WOMAN}
                      onChange={handleChange}
                    />
                    <label className="form-check-label mx-2" htmlFor="gender-woman">
                      {constClass.GENDER_NAME.WOMAN}
                    </label>
                  </div>
                  <div className="form-check col-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="gender-other"
                      name="gender"
                      value={constClass.GENDER.OTHER}
                      checked={values.gender === constClass.GENDER.OTHER}
                      onChange={handleChange}
                    />
                    <label className="form-check-label mx-2" htmlFor="gender-other">
                      {constClass.GENDER_NAME.OTHER}
                    </label>
                  </div>
                  <div className="form-check col-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="gender-notspecified"
                      name="gender"
                      value={constClass.GENDER.NOTSPECIFIED}
                      checked={values.gender === constClass.GENDER.NOTSPECIFIED}
                      onChange={handleChange}
                    />
                    <label className="form-check-label mx-2" htmlFor="gender-notspecified">
                      {constClass.GENDER_NAME.NOTSPECIFIED}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="expiry">有効期限</label>
            </div>
            <div className="col-2 align-self-center">
              <input type="text" className="form-control" name="expiry" id="expiry" value={values.end_month_flag === constClass.FLAG.ON ? "" : values.expiry} onChange={handleChange} disabled={values.end_month_flag === constClass.FLAG.ON}></input>
            </div>
            <div className="col-1 align-self-center">
              <label htmlFor="expiry">日後</label>
            </div>
            <div className="col-2 text-center align-self-center">
              <label htmlFor="end_month_flag">当月末</label>
            </div>
            <div className="col-5 text-center align-self-center">
              <input type="checkbox" className="form-control w-25" name="end_month_flag" value="true" checked={values.end_month_flag === constClass.FLAG.ON} onChange={handleChange} disabled={values.expiry}></input>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="release_date">配信日<br /><span className="text-secondary small">（日付のみ、例: 05）</span></label>
            </div>
            <div className="col-2 align-self-center">
              <input
                type="text"
                className="form-control"
                name="release_date"
                value={values.release_date}
                onChange={handleChange}
                placeholder="DD"
                maxLength={2}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="message_text">通知メッセージ(Flex)</label>
            </div>
            <div className="col-5 align-self-center">
              <textarea className="form-control" rows="3" name="message_text" id="message_text" value={values.message_text} onChange={handleChange}></textarea>
            </div>
          </div>
        </div>
      </div>
          <div className="row mt-4 d-flex justify-content-center">
            <div className="col-3 text-center">
              {renderRegistButton(values)}
            </div>
          </div>
    </div>
  );
}

export default CouponDetail;